import { render, staticRenderFns } from "./promotion-total-bills.vue?vue&type=template&id=870d81c8&scoped=true"
import script from "./promotion-total-bills.vue?vue&type=script&lang=js"
export * from "./promotion-total-bills.vue?vue&type=script&lang=js"
import style0 from "./promotion-total-bills.vue?vue&type=style&index=0&id=870d81c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870d81c8",
  null
  
)

export default component.exports